export const useHost = () => {
  return process.env.AUTH_PF_DOCTOR_API_HOST!
}
